'use strict';
// Versiones de la LBEn (6.5): mismas reglas y mensajes que aplicarLb() y adoptarVar2() del prototipo, sin DOM.
// Reciben una instalación normalizada y recalculada (motor.recalcular) y devuelven la versión nueva SIN fecha ni
// usuario: los pone el servidor (hoja 23: «fecha/hora del SERVIDOR»). El historial es inmutable: solo se agregan
// versiones. Un error se lanza como ErrorLineaBase con el mensaje para el usuario.
const P = require('./prototipo');

class ErrorLineaBase extends Error {}

const MES = /^\d{4}-(0[1-9]|1[0-2])$/;
const motivoDe = (m) => String(m == null ? '' : m).trim();
const numeroVersion = (f) => (f.lbHist || []).length + 2; // la versión 1 es la inicial (sin registro)

function nuevaVersionPeriodo(f, { desde, hasta, motivo }) {
  if (!desde || !hasta || !MES.test(desde) || !MES.test(hasta) || desde > hasta) {
    throw new ErrorLineaBase('El período no es válido: «desde» debe ser anterior o igual a «hasta».');
  }
  const mo = motivoDe(motivo);
  if (!mo) throw new ErrorLineaBase('Escribí el motivo del cambio: la norma (6.5) pide conservar las modificaciones de la línea de base.');
  const sp = P.lbSplit(f);
  const anterior = sp.base.length ? sp.base[0].month + ' a ' + sp.base[sp.base.length - 1].month : '—';
  if (sp.base.length && sp.base[0].month === desde && sp.base[sp.base.length - 1].month === hasta) {
    throw new ErrorLineaBase('Es el mismo período de la versión vigente: no se registra una versión nueva.');
  }
  const m = f._monthly || [];
  const nBase = m.filter((x) => P.okLb(x) && x.month >= desde && x.month <= hasta).length;
  const nRep = m.filter((x) => P.okLb(x) && x.month > hasta).length;
  if (nBase < P.N_MIN) {
    throw new ErrorLineaBase(`El período elegido tiene ${nBase} meses válidos: hacen falta al menos ${P.N_MIN} (criterio interno Sustemia).`);
  }
  return {
    version: { version: numeroVersion(f), tipo: 'periodo', modelo: f.lbModelo === 'var2' ? '2 variables' : '1 variable', anterior, desde, hasta, motivo: mo },
    lb: { desde, hasta },
    aviso: nRep < P.N_REP_MIN
      ? `Versión registrada. Atención: quedan ${nRep} mes(es) de reporte; la mejora se evalúa con al menos ${P.N_REP_MIN}.`
      : null,
  };
}

// Comparación de modelos que muestra la pantalla (renderVar2): ¿se puede adoptar el de 2 variables?
function evaluarVar2(f) {
  if (!P.tieneVar2(f)) return { disponible: false, motivo: 'Sin datos de la variable 2 en todos los meses del período base.' };
  const m = P.lbSplit(f).base;
  const r1 = P.linreg(m.map((x) => x.production), m.map((x) => x.energy));
  const r2 = P.linreg2(m.map((x) => x.production), m.map((x) => x.var2), m.map((x) => x.energy));
  if (!r2) return { disponible: false, motivo: 'No se pudo ajustar el modelo de dos variables (los datos son colineales o insuficientes).', r1 };
  const significativa = r2.p[1] < P.P_MAX && r2.p[2] < P.P_MAX;
  const mejora = isFinite(r2.cvrmse) && isFinite(r1.cvrmse) && r2.cvrmse < r1.cvrmse;
  return { disponible: significativa && mejora, significativa, mejora, r1, r2 };
}

function nuevaVersionModelo(f, { adoptar, motivo }) {
  const mo = motivoDe(motivo);
  const sp = P.lbSplit(f);
  const desde = (sp.base[0] || {}).month || '';
  const hasta = (sp.base[sp.base.length - 1] || {}).month || '';
  if (adoptar) {
    if (f.lbModelo === 'var2') throw new ErrorLineaBase('El modelo de 2 variables ya es la línea de base vigente.');
    const ev = evaluarVar2(f);
    if (!ev.disponible) {
      throw new ErrorLineaBase(ev.motivo || 'El modelo de 2 variables solo se adopta si ambas variables son significativas (p < 0,10) y el CV(RMSE) mejora.');
    }
    if (!mo) throw new ErrorLineaBase('Escribí el motivo: la norma (6.5) pide conservar las modificaciones de la LBEn.');
    return { version: { version: numeroVersion(f), tipo: 'modelo', modelo: '2 variables', anterior: P.lbEtiqueta(f._reg), desde, hasta, motivo: mo }, lbModelo: 'var2' };
  }
  if (f.lbModelo !== 'var2') throw new ErrorLineaBase('La línea de base vigente ya es el modelo de una variable.');
  if (!mo) throw new ErrorLineaBase('Escribí el motivo para volver al modelo de una variable: la norma (6.5) pide conservar las modificaciones de la LBEn.');
  return { version: { version: numeroVersion(f), tipo: 'modelo', modelo: '1 variable', anterior: 'Modelo de 2 variables', desde, hasta, motivo: mo }, lbModelo: null };
}

module.exports = { ErrorLineaBase, nuevaVersionPeriodo, nuevaVersionModelo, evaluarVar2 };
